import { render } from "./CalificacionesGraficas.vue?vue&type=template&id=753d536f"
import script from "./CalificacionesGraficas.vue?vue&type=script&lang=js"
export * from "./CalificacionesGraficas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__